import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../styles/header.css";
import PreviewHeader from "./PreviewHeader";

const Header = React.memo(function Header() {
  const location = useLocation();
  const [pathName, setPathName] = useState("");

  useEffect(() => {
    setPathName(location.pathname);
  }, [location]);

  if (pathName === "/sitegeneration/preview") {
    return <PreviewHeader />;
  }

  return (
    <header className="ns-header">
      <div className="ns-header-container">

        <a href="https://www.networksolutions.com?brand=web&siteID=100&channelID=P99C100S653N0B5A1D0E0000V100" className="ns-logo-link">
          <img
            src="/sitegeneration/NetworkSolutionsLogo.svg"
            alt="Network Solutions Logo"
            className="ns-logo-img"
          />
        </a>

        <nav className="ns-nav">
          <a
            href="https://www.networksolutions.com/blog?brand=web&siteID=100&channelID=P99C100S653N0B5A1D0E0000V100"
            rel="noopener noreferrer"
            className="ns-nav-link"
          >
            <span className="ns-nav-text">Blog</span>
          </a>

          <a
            href="https://www.networksolutions.com/help?brand=web&siteID=100&channelID=P99C100S653N0B5A1D0E0000V100"
            rel="noopener noreferrer"
            className="ns-nav-link link-with-icon"
          >
            <img
              src="/sitegeneration/icons/help-icon.svg"
              alt="Help Icon"
              className="icon"
            />
            <span className="ns-nav-text">Support</span>
          </a>

          <a
            href="https://www.networksolutions.com/my-account/login?brand=web&siteID=100&channelID=P99C100S653N0B5A1D0E0000V100"
            rel="noopener noreferrer"
            className="ns-nav-link link-with-icon"
          >
            <img
              src="/sitegeneration/icons/account-circle-icon.svg"
              alt="Account Icon"
              className="icon"
            />
            <span className="ns-nav-text">Log In</span>
          </a>
        </nav>

      </div>
    </header>
  );
})

export default Header;
